import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import handleApiError from "../../helpers/handleApiError";
import fileDownload from "js-file-download";
import {
  getParcelImage,
  getPublicTrackerParcelImage,
} from "../../services/deliveryService";
import {
  BsArrowClockwise,
  BsArrowCounterclockwise,
  BsChevronLeft,
  BsChevronRight,
  BsX,
} from "react-icons/bs";
import { isClient } from "../../services/accountService";
import cdkDemoPODImage from "../../assets/demo assets/CC Example POD image.jpg";
import { useQuery } from "@tanstack/react-query";

export const FullPageParcelImageModal = ({
  show,
  handleCloseModal,
  selectedImage,
  imageIDArray,
  barcode,
  invoice,
  textUnderImage,
  isPublicTracker,
  isDemoAccount,
}) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [imageData, setImageData] = useState(); //currently using {base64EncodedData, description, updatedWhen:{formattedDate, formattedTime}}
  const [rotation, setRotation] = useState(0);
  const handleRotateClockWise = () => {
    setRotation((prev) => prev + 90);
  };
  const handleRotateCounterClockWise = () => {
    setRotation((prev) => prev - 90);
  };
  const handleCloseModalWrapper = () => {
    setRotation(0);
    handleCloseModal();
  };
  const [currentImage, setCurrentImage] = useState(selectedImage);
  useEffect(() => {
    setCurrentImage(selectedImage);
  }, [selectedImage, show]);
  const currentImageIndex = imageIDArray?.findIndex(
    (image) => image == currentImage,
  );
  const showRightArrow = currentImageIndex < imageIDArray?.length - 1;
  const showLeftArrow = currentImageIndex > 0;
  // console.log("imagesArray", imageIDArray);
  // console.log("selectedImage", selectedImage);
  // console.log("currentImageIndex", currentImageIndex);
  const handleNavigateToNextImage = () => {
    setCurrentImage(imageIDArray[currentImageIndex + 1]);
    setRotation(0);
  };
  const handleNavigateToPreviousImage = () => {
    setCurrentImage(imageIDArray[currentImageIndex - 1]);
    setRotation(0);
  };

  // useEffect(() => {
  //   let isMounted = true;
  //   const fetchData = async () => {
  //     try {
  //       setIsLoading(true);
  //       // console.log("hi");
  //       // const dontintercept = axios.create();
  //       // const imageResponse = await dontintercept.get(imageURLToFetch, {
  //       //   headers: { Authorization: "Token 5b6c3163c95e4110ab7324399ac0cb4e" },
  //       //   params: { convertTo: "JPG" },
  //       // });
  //       const imageEndpoint = isPublicTracker
  //         ? getPublicTrackerParcelImage
  //         : getParcelImage;
  //       if (isDemoAccount) {
  //         setImageData({
  //           base64EncodedData: cdkDemoPODImage,
  //           description: "Package Delivered",
  //           updatedWhen: {
  //             formattedDate: new Date().toLocaleDateString("en-US"),
  //             formattedTime: "3:52 PM",
  //           },
  //         });
  //       } else {
  //         const imageResponse = await imageEndpoint(currentImage, isClient()); //for public tracker isClient() is disregarded but shouldn't cause an issue for now
  //         if (isMounted) {
  //           // console.log(imageResponse);
  //           setImageData(imageResponse.data);
  //         }
  //       }
  //       if (isMounted) {
  //         setIsLoading(false);
  //       }
  //     } catch (ex) {
  //       handleApiError(ex, history);
  //       // console.log(ex);
  //       if (isMounted) {
  //         setIsLoading(false);
  //       }
  //     }
  //   };
  //   //only if show is true do we actually want to run the mount code //there may be a better pattern to do this
  //   if (show && currentImage) {
  //     // console.log(selectedImage);
  //     fetchData();
  //   }

  //   return () => {
  //     isMounted = false;
  //   };
  // }, [show, currentImage, history]);
  const {
    data: imageDataUQ,
    isLoading: isLoadingUQ,
    isError: isErrorUQ,
  } = useQuery({
    queryKey: ["podImage", currentImage],
    staleTime: 60 * 1000,
    cacheTime: 60 * 1000,
    queryFn: async () => {
      const imageEndpoint = isPublicTracker
        ? getPublicTrackerParcelImage
        : getParcelImage;
      if (isDemoAccount) {
        return {
          base64EncodedData: cdkDemoPODImage,
          description: "Package Delivered",
          updatedWhen: {
            formattedDate: new Date().toLocaleDateString("en-US"),
            formattedTime: "3:52 PM",
          },
        };
      } else {
        const imageResponse = await imageEndpoint(currentImage, isClient()); //for public tracker isClient() is disregarded but shouldn't cause an issue for now
        // setImageData(imageResponse.data);
        return imageResponse?.data;
      }
    },
    enabled: currentImage != undefined && currentImage != null,
  });
  // console.log("use query - is loading", isLoadingUQ);

  const downloadImageClick = async () => {
    // console.log(imageData?.base64EncodedData);
    let imageToDownloadResponse = await fetch(
      isDemoAccount
        ? imageDataUQ?.base64EncodedData
        : "data:image/jpg;base64," + imageDataUQ?.base64EncodedData,
    );
    let imageToDownload = await imageToDownloadResponse.blob();

    const typeFile = barcode
      ? `Diligent Barcode ${barcode}`
      : `Diligent Invoice ${invoice}`;

    fileDownload(
      imageToDownload,
      `${typeFile} - ${imageDataUQ.description} - ${imageDataUQ?.updatedWhen?.formattedDate} at ${imageDataUQ?.updatedWhen?.formattedTime}.jpg`,
      "image/jpg",
    );
  };

  return (
    <Modal
      show={show}
      onHide={handleCloseModalWrapper}
      className="full-page-parcel-image-modal-container"
      dialogClassName="full-page-parcel-image-modal-dialog"
      contentClassName="full-page-parcel-image-modal-content"
      animation={false}
    >
      <div
        role="button"
        className="d-none d-sm-block btn-press"
        onClick={handleCloseModalWrapper}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: 2000000,
        }}
      >
        <BsX
          size={45}
          style={{
            margin: "-7px",
            filter: "drop-shadow(0px 1px 2px rgb(0, 0, 0))",
          }}
        />
      </div>
      <div
        role="button"
        className="d-none d-sm-block btn-press"
        onClick={handleRotateClockWise}
        style={{
          position: "absolute",
          top: "3rem",
          right: 0,
          zIndex: 2000000,
        }}
      >
        <BsArrowClockwise
          size={45}
          style={{
            margin: "-7px",
            filter: "drop-shadow(0px 1px 2px rgb(0, 0, 0))",
          }}
        />
      </div>
      <div
        role="button"
        className="d-none d-sm-block btn-press"
        onClick={handleRotateCounterClockWise}
        style={{
          position: "absolute",
          top: "6rem",
          right: 0,
          zIndex: 2000000,
        }}
      >
        <BsArrowCounterclockwise
          size={45}
          style={{
            margin: "-7px",
            filter: "drop-shadow(0px 1px 2px rgb(0, 0, 0))",
          }}
        />
      </div>
      {showLeftArrow && (
        <div
          role="button"
          className="d-none d-sm-block btn-press"
          onClick={handleNavigateToPreviousImage}
          style={{
            position: "absolute",
            top: "50%",
            left: 0,
            zIndex: 2000000,
          }}
        >
          <BsChevronLeft
            size={45}
            style={{
              margin: "-7px",
              filter: "drop-shadow(0px 1px 2px rgb(0, 0, 0))",
            }}
          />
        </div>
      )}
      {showRightArrow && (
        <div
          role="button"
          className="d-none d-sm-block btn-press"
          onClick={handleNavigateToNextImage}
          style={{
            position: "absolute",
            top: "50%",
            right: 0,
            zIndex: 2000000,
          }}
        >
          <BsChevronRight
            size={45}
            style={{
              margin: "-7px",
              filter: "drop-shadow(0px 1px 2px rgb(0, 0, 0))",
            }}
          />
        </div>
      )}
      {isLoadingUQ ? (
        <div
          className="spinner-border"
          role="status"
          style={{
            position: "absolute",
            top: "calc(50% - 1.5rem)",
            left: "calc(50% - 1.5rem)",
            width: "3rem",
            height: "3rem",
          }}
        >
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <>
          <div
            className="full-page-parcel-image-modal-title"
            style={{ position: "relative" }}
          >
            {!textUnderImage && (
              <>
                {barcode && (
                  <p className="h4" style={{ margin: 0 }}>
                    Barcode {barcode}
                  </p>
                )}

                {invoice && (
                  <p className="h4" style={{ margin: 0 }}>
                    Invoice {invoice}
                  </p>
                )}
                <p className="h5">
                  {imageDataUQ?.fileName} on{" "}
                  {imageDataUQ?.updatedWhen?.formattedDate +
                    " at " +
                    imageDataUQ?.updatedWhen?.formattedTime}
                  <br />
                  Description: <br /> {imageDataUQ?.description}
                </p>
              </>
            )}
          </div>
          {imageDataUQ && (
            <div style={{ height: "100%", margin: "auto" }}>
              <img
                className="full-page-parcel-image-modal-img no-copy"
                style={{
                  transform: "rotate(" + rotation + "deg)",
                  transition: "transform 0.3s ease",
                }}
                src={
                  isDemoAccount
                    ? imageDataUQ?.base64EncodedData
                    : "data:image/jpg;base64," + imageDataUQ?.base64EncodedData
                }
                alt="Signature"
              />
            </div>
          )}
          <div className="d-flex align-items-center flex-column mt-2">
            {textUnderImage && (
              <div
                className="full-page-parcel-image-modal-title"
                style={{ textAlign: "center" }}
              >
                {barcode && (
                  <p className="h4" style={{ margin: 0 }}>
                    Barcode {barcode}
                  </p>
                )}
                {invoice && (
                  <p className="h4" style={{ margin: 0 }}>
                    Invoice {invoice}
                  </p>
                )}

                <p className="h5">
                  {imageDataUQ?.fileName} on{" "}
                  {imageDataUQ?.updatedWhen?.formattedDate +
                    " " +
                    imageDataUQ?.updatedWhen?.formattedTime}
                  <br />
                  Description: <br /> {imageDataUQ?.description}
                </p>
              </div>
            )}
            <button
              style={{ width: "500px", justifySelf: "center" }}
              className="btn btn-primary mb-1"
              onClick={downloadImageClick}
            >
              Download
            </button>
            <button
              style={{ width: "500px", justifySelf: "center" }}
              className="btn btn-secondary mb-1"
              onClick={handleCloseModalWrapper}
            >
              Close
            </button>
          </div>
        </>
      )}
    </Modal>
  );
};
